<h3 translate>walk-step-intro.component.title</h3>
<p translate>walk-step-intro.component.info.intro</p>
<lv-script-toggle>
  <p translate>walk-step-intro.component.script.intro</p>
  <p translate>walk-step-intro.component.script.body</p>
  <p translate>walk-step-intro.component.script.outro</p>
</lv-script-toggle>
<p translate>walk-step-intro.component.info.outro</p>
